// src/PublicBioPage.js
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PublicBioPageDesktop from './desktopView';
import PublicBioPageMobile from './mobileView';

/**
 * Main PublicBioPage component that routes to device-specific viewers
 * Detects device type and renders appropriate interface
 */
export default function PublicBioPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Route to appropriate viewer based on device
  return isMobile ? <PublicBioPageMobile /> : <PublicBioPageDesktop />;
}